import { RiFileTextLine, RiEyeLine, RiDeleteBinLine, RiCheckboxCircleLine, RiCheckboxBlankCircleLine } from 'react-icons/ri';
import type { Resume } from '../../models/v2/profile';

interface Props {
    resume: Resume;
    onPreview: (resume: Resume) => void;
    onSetDefault: (resume: Resume) => void;
    onDelete: (resume: Resume) => void;
}

export default function ResumeCard({ resume, onPreview, onSetDefault, onDelete }: Props) {
    return (
        <div className="group p-4 rounded-xl bg-white/5 border border-white/5 hover:border-white/10 hover:bg-white/10 transition-all flex items-center justify-between">
            <div className="flex items-center gap-4">
                <div className={`w-12 h-12 rounded-lg flex items-center justify-center text-xl ${Boolean(Number(resume.is_default)) ? 'bg-blue-500/20 text-blue-400' : 'bg-gray-700/30 text-gray-400'}`}>
                    <RiFileTextLine />
                </div>
                <div>
                    <h4 className="text-white font-medium truncate max-w-[200px]" title={resume.name}>
                        {resume.name}
                    </h4>
                    <div className="flex items-center gap-2 mt-1">
                        <span className="text-xs text-zinc-500">
                            Uploaded {new Date(resume.created_at).toLocaleDateString()}
                        </span>
                        {/* Handle potential string/number 0/1 from backend */}
                        {Boolean(Number(resume.is_default)) && (
                            <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-blue-500/10 text-blue-400 border border-blue-500/20">
                                Default
                            </span>
                        )}
                    </div>
                </div>
            </div>

            <div className="flex items-center gap-1 opacity-100 sm:opacity-0 sm:group-hover:opacity-100 transition-opacity">
                <button
                    onClick={() => onPreview(resume)}
                    className="p-2 rounded-lg text-zinc-400 hover:text-white hover:bg-white/10 transition-colors"
                    title="Preview"
                >
                    <RiEyeLine size={18} />
                </button>

                {!Boolean(Number(resume.is_default)) && (
                    <button
                        onClick={() => onSetDefault(resume)}
                        className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-zinc-400 hover:text-blue-400 hover:bg-blue-500/10 transition-colors text-xs font-medium"
                        title="Set as Default"
                    >
                        <RiCheckboxBlankCircleLine size={16} />
                        <span className="hidden sm:inline">Make Default</span>
                    </button>
                )}

                {Boolean(Number(resume.is_default)) && (
                    <button
                        disabled
                        className="p-2 rounded-lg text-blue-400 cursor-default"
                        title="Current Default"
                    >
                        <RiCheckboxCircleLine size={18} />
                    </button>
                )}

                <button
                    onClick={() => onDelete(resume)}
                    className="p-2 rounded-lg text-zinc-400 hover:text-red-400 hover:bg-red-500/10 transition-colors"
                    title="Delete"
                >
                    <RiDeleteBinLine size={18} />
                </button>
            </div>
        </div>
    );
}
